/// Google Form для обратной связи от пользователей приложения.
export const FeedbackConfig = {
  formId: '1UUp3YVwltcojYpm6y-YsgLgxE-9Km1k7Nqq5yA8kyGs',
  responsesUrl:
    'https://docs.google.com/forms/d/1UUp3YVwltcojYpm6y-YsgLgxE-9Km1k7Nqq5yA8kyGs/edit#responses',
} as const
